var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-container',[(_vm.$store.getters.isPC)?_c('el-aside',[_c('Menu')],1):_vm._e(),_c('el-main',[_c('router-view',{key:_vm.getAuthorityRoute,staticClass:"main-router-view"}),(_vm.$store.getters.authorityRoute !== '/parent')?_c('Footer'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }